export const defaultDebounce = 300;
export const defaultMockTime = 1500;
